<template>

    <div class="ui dimmer modals page transition" :class="{'show visible active': show}">
        <div class="ui basic modal transition visible active" style="margin-top: -140px; display: block !important;">
            <i class="close icon" @click="close"></i>
            <div class="header">
                {{ lang.say('CHECK_REMOVE_ALL') }}
            </div>
            <div class="image content">
                <div class="image">
                    <i class="trash icon"></i>
                </div>
                <div class="description">
                    <p>{{ lang.say('CHECK_REMOVE_ALL_DESC') }}</p>
                </div>
            </div>
            <div class="actions">
                <div class="two fluid ui inverted buttons">
                    <div class="ui red basic cancel inverted button" @click="cancel">
                        <i class="remove icon"></i>
                        No
                    </div>
                    <div class="ui green basic ok inverted button" @click="confirm">
                        <i class="checkmark icon"></i>
                        Yes
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import lang from '../lang';

    export default {
        data() {
            return {
                lang
            }
        },
        props: ['show'],
        methods: {
            cancel() {
                this.$emit('confirm', false);
            },
            confirm() {
                this.$emit('confirm', true);
            },
            close() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>
    .show {
        display: block !important;
    }
</style>


// WEBPACK FOOTER //
// MaskForCheckToRemoveAllProducts.vue?d47cf146